import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6f71258295d500143ae5ca_1786708427348_7129025d/worldwayluxe/src/app/activities/page.tsx");
